<template>
  <div class="page-landing">

    <div v-for="(block, index) in blocks"
      :key="`${index}`">

      <info-block
        v-if="(
          Util.object.getMetaAttr(block, 'arrangement') === 'left-header-right-image' ||
          Util.object.getMetaAttr(block, 'arrangement') === 'top-header' ||
          Util.object.getMetaAttr(block, 'arrangement') === 'top-header-bottom-image'
        )"
        :data="block"
        :is-centered="
          block.name === 'page-landing-services' ||
          block.name === 'page-landing-testimonials'"
        :no-header="
          block.name === 'page-landing-awards'"
        :no-gap-top="true"
        :no-gap-bottom="
          block.name === 'page-landing-testimonials'">

        <div v-if="block.name === 'page-landing-services'" slot="default" id="services">
          <div class="is-gap-top is-gap-bottom">
            <el-button
              v-for="(service, sindex) in services" :key="`s-${sindex}`"
              class="button color-green-bg" style="margin:6px;"
              @click="onClick('service.name', service && service.name)">
              {{ (service && service.subtitle) || '(null)' }}
            </el-button>
          </div>
        </div>

        <div v-else-if="block.name === 'page-landing-testimonials'" slot="out-container">
          <testimonials></testimonials>
        </div>

        <div v-else-if="block.name === 'page-landing-awards'" slot="out-container">
          <awards :data="sponsors"></awards>
        </div>

      </info-block>

      <div v-else>
        (Invalid Block)
      </div>

    </div>

  </div>
</template>

<script>
import Util from '@/util'
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/site'

import InfoBlock from '@/pages/base/infoblock'
import Testimonials from './testimonials'
import Awards from './awards'

export default {
  name: 'page-landing',
  props: {
    // msg: String
  },
  components: {
    InfoBlock,
    Testimonials,
    Awards,
  },
  data () {
    return {
      isDesktop: true,
      loading: false,
      blocks: [],
      sponsors: [],
      services: [],
    }
  },
  computed: {
    Util: function () {
      return Util
    }
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 2000)
    }

    await this.refresh()
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: 100 })
      }
    },

    async refresh () {
      try {
        this.$set(this, 'loading', true)
        let promises = []
        let promise
        promise = this.getBlocks()
        promises.push(promise)
        promise = this.getSponsors()
        promises.push(promise)
        promise = this.getServices()
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getBlocks () {
      this.$set(this, 'blocks', [])
      let data = await Site.infoNamedLike('page-landing')
      this.$set(this, 'blocks', data)
    },

    async getSponsors () {
      this.$set(this, 'sponsors', [])
      let data = await Site.sponsors()
      this.$set(this, 'sponsors', data)
    },

    async getServices () {
      this.$set(this, 'services', [])
      let data = await Site.services()
      this.$set(this, 'services', data)
    },

    onClick (route, name) {
      this.$router.push({ name: route, params: { name } })
    }
  },
}
</script>

<style lang="scss" src="../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../styles/app_setting.scss";

.page-landing {
  // the magic
  .banner-wrapper {
    // background-image: url("../assets/image-01.jpg");
    background-repeat: no-repeat;
    background-color: #dedede;
    background-position: 50% 50%;
    background-size: 100% auto;
    width: 100%;
    min-height: 300px;
    &.is-full {
      min-height: auto;
    }
    @media screen and (max-width: $mobile) {
      min-height: 0px;
    }

    &.is-hidden-tablet {
      background-image: none;
      background: $color-primary-blue;
    }
  }
}

</style>
